import { memo, useState } from "react";
import { CachedImage } from "@/components/blocks/cached-image";
import { ImageOverlay } from "@/components/blocks/image-overlay";
import { cn } from "@/lib/utils";

export const ImageOrLink = memo(
  ({
    url,
    //@ts-ignore
    lazyLoad = false,
    imgClassName = "",
    linkClassName = "",
  }: {
    url: string;
    lazyLoad?: boolean;
    imgClassName?: string;
    linkClassName?: string;
  }) => {
    const [isImage, setIsImage] = useState(true);
    const [showOverlay, setShowOverlay] = useState(false);
    const handleImageClick = (e: React.MouseEvent) => {
      e.preventDefault();
      setShowOverlay(true);
    };

    return (
      <>
        {isImage ? (
          <>
            <a
              href={url}
              target="_blank"
              rel="noopener noreferrer"
              className={linkClassName}
            >
              <div className="truncate max-w-xs">{url}</div>
            </a>
            <CachedImage
              src={url}
              //loading={lazyLoad ? "lazy" : "eager"}
              alt={url}
              //onLoad={() => setIsLoading(false)}
              onError={() => setIsImage(false)}
              className={cn("cursor-pointer", imgClassName)}
              onClick={handleImageClick}
            />
            {showOverlay && (
              <ImageOverlay src={url} onClose={() => setShowOverlay(false)} />
            )}
          </>
        ) : (
          <a
            href={url}
            target="_blank"
            rel="noopener noreferrer"
            className={linkClassName}
          >
            {url}
          </a>
        )}
      </>
    );
  },
);
